import { render, staticRenderFns } from "./AddQuestionsQuestionary.vue?vue&type=template&id=473b40f3&"
import script from "./AddQuestionsQuestionary.vue?vue&type=script&lang=js&"
export * from "./AddQuestionsQuestionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports